import { createElement } from "react";
import React from "react";
import * as react from "react";
import { equals, uncurry2, int32ToString, compare as compare_1, stringHash, comparePrimitives, compareArrays, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { head, tail, tryHead as tryHead_1, tryFind, iterate, reverse, append as append_1, ofSeq as ofSeq_1, sort, cons, map as map_1, max, min, choose, length, filter, exists, isEmpty, ofArray, singleton as singleton_1, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { filter as filter_2, length as length_1, mapIndexed, map as map_2, collect, empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { op_PlusPlus } from "../fable_modules/Feliz.Bulma.3.0.0/Operators.fs.js";
import { orElse, some, map2, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { op_Subtraction } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { utcNow, toString as toString_1, compare } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { Csv_encode, Thoth_Fetch_FetchError__FetchError_get_Message, Fetch_Types_Response__Response_ProblemDetails, Humanize_timeSpan, System_Int32__Int32_ToLocaleString } from "../Prelude.fs.js";
import { PromiseBuilder__For_1565554B, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { TaskMsg, useFeliz_UseElmish_React__React_useTaskDispatch_Static } from "../hooks/UseTaskDispatch.fs.js";
import { ChangeAttributes, ChangeLabels, DeleteEntity } from "../ServerTypes.fs.js";
import { DomainEntity__get_Labels, DomainEntity__get_DomainEntity, Entity__get_Name, Entity__get_Id, DomainEntity__get_Detail, DomainEntity__get_Name, DomainEntity__get_Id } from "../ClientTypes.fs.js";
import { changeAttributes as changeAttributes_7, changeLabels as changeLabels_1, undelete, delete$ as delete$_1 } from "../Api/Facilities.fs.js";
import { changeAttributes, changeLabels as changeLabels_2, undelete as undelete_1, delete$ as delete$_2 } from "../Api/Modules.fs.js";
import { changeAttributes as changeAttributes_1, changeLabels as changeLabels_3, undelete as undelete_2, delete$ as delete$_3 } from "../Api/Areas.fs.js";
import { changeAttributes as changeAttributes_2, changeLabels as changeLabels_4, undelete as undelete_3, delete$ as delete$_4 } from "../Api/Locations.fs.js";
import { undelete as undelete_4, delete$ as delete$_5 } from "../Api/ProductionUnitTypes.fs.js";
import { changeAttributes as changeAttributes_3, changeLabels as changeLabels_5, undelete as undelete_5, delete$ as delete$_6 } from "../Api/ProductionUnits.fs.js";
import { changeAttributes as changeAttributes_4, changeLabels as changeLabels_6, undelete as undelete_6, delete$ as delete$_7 } from "../Api/Systems.fs.js";
import { changeAttributes as changeAttributes_5, changeLabels as changeLabels_7, undelete as undelete_7, delete$ as delete$_8 } from "../Api/Subsystems.fs.js";
import { changeAttributes as changeAttributes_6, changeLabels as changeLabels_8, undelete as undelete_8, delete$ as delete$_9 } from "../Api/Tags.fs.js";
import { changeLabels as changeLabels_9, undelete as undelete_9, delete$ as delete$_10 } from "../Api/Documents.fs.js";
import { undelete as undelete_10, delete$ as delete$_11 } from "../Api/ActionTypes.fs.js";
import { changeLabels as changeLabels_10, undelete as undelete_11, delete$ as delete$_12 } from "../Api/Activities.fs.js";
import { undelete as undelete_12, delete$ as delete$_13 } from "../Api/Disciplines.fs.js";
import { undelete as undelete_13, delete$ as delete$_14 } from "../Api/EquipmentTypes.fs.js";
import { changeLabels as changeLabels_11, undelete as undelete_14, delete$ as delete$_15 } from "../Api/Actions.fs.js";
import { interpolate, toText, join, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { toString, FSharpRef, Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { bool_type, option_type, list_type, union_type, record_type, class_type, tuple_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Cmd_ofEffect, Cmd_OfPromise_perform, Cmd_none } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { empty as empty_2, unionMany, filter as filter_1, union, FSharpSet__Contains, partition, difference, intersectMany, ofSeq, add, remove } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/./UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Feliz.UseElmish.2.5.0/../Fable.Elmish.4.2.0/program.fs.js";
import { FSharpMap__TryFind, ofList, ofSeq as ofSeq_2 } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { groupBy } from "../fable_modules/fable-library-js.4.24.0/Seq2.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Fa_IconOption, Fa_i } from "../fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { Attribute, Attribute_$reflection } from "../DomainEvents.fs.js";
import { tryParse } from "../fable_modules/fable-library-js.4.24.0/Double.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.24.0/Range.js";
import { StringBuilder__AppendLine_Z721C83C5, StringBuilder_$ctor } from "../fable_modules/fable-library-js.4.24.0/System.Text.js";
import file_saver from "file-saver";
import { tryHead } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { PhotoSettings } from "../Bindings/ImageCapture.fs.js";
import { newGuid } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import { fromString } from "../hooks/../fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { toString as toString_2 } from "../hooks/../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Impl_createRemoveOptions, Impl_adjustPassive, Impl_defaultPassive } from "../fable_modules/Feliz.Listeners.1.1.0/./Listener.fs.js";
import { useEffect } from "../fable_modules/Feliz.2.9.0/./ReactInterop.js";
import { createDisposable, useCallbackRef } from "../fable_modules/Feliz.2.9.0/./Internal.fs.js";

export function Modal_ModalWithFooter(props) {
    let elems_4, elms_2, elms;
    return createElement("div", createObj(Helpers_combineClasses("modal", ofArray([["className", "is-active"], (elems_4 = [createElement("div", createObj(Helpers_combineClasses("modal-background", empty()))), (elms_2 = ofArray([(elms = toList(delay(() => append(singleton(createElement("p", {
        className: "modal-card-title",
        children: props.title,
    })), delay(() => (!props.disabled ? singleton(createElement("button", createObj(Helpers_combineClasses("delete", singleton_1(["onClick", (_arg) => {
        props.close();
    }]))))) : empty_1()))))), createElement("header", {
        className: "modal-card-head",
        children: reactApi.Children.toArray(Array.from(elms)),
    })), createElement("section", {
        className: "modal-card-body",
        children: reactApi.Children.toArray([props.content]),
    }), createElement("footer", {
        className: "modal-card-foot",
        children: reactApi.Children.toArray(Array.from(props.footer)),
    })]), createElement("div", {
        className: "modal-card",
        children: reactApi.Children.toArray(Array.from(elms_2)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
}

function Modal_taskOutput(task) {
    let elems, elems_1, elems_2;
    const matchValue = task.State;
    switch (matchValue.tag) {
        case 2:
            return createElement("details", createObj(ofArray([op_PlusPlus(["className", "notification"], ["className", "is-success"]), (elems = [createElement("summary", {
                children: [`${task.Name} Success`],
            }), defaultArg(map((children) => createElement("blockquote", {
                children: [children],
            }), matchValue.fields[0]), defaultOf())], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        case 3:
            return createElement("details", createObj(ofArray([op_PlusPlus(["className", "notification"], ["className", "is-danger"]), (elems_1 = [createElement("summary", {
                children: [`${task.Name} Failed`],
            }), defaultArg(map((children_1) => createElement("blockquote", {
                children: [children_1],
            }), matchValue.fields[0]), defaultOf())], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
        case 4: {
            const problemDetails = matchValue.fields[0];
            return createElement("details", createObj(ofArray([op_PlusPlus(["className", "notification"], ["className", "is-danger"]), (elems_2 = [createElement("summary", {
                children: [`${task.Name} Failed: ${problemDetails.Title}`],
            }), defaultArg(map((children_2) => createElement("blockquote", {
                children: [children_2],
            }), problemDetails.Detail), defaultOf())], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
        }
        default:
            return defaultOf();
    }
}

export function Modal_ModalWithBreakdown(props) {
    let matchValue_3, matchValue_4, elems_13, elms_7, elms, elms_5, elms_6;
    const allFinished = isEmpty(props.tasks) ? false : !exists((t) => (t.Finished == null), props.tasks);
    const started = exists((t_1) => (t_1.Started != null), props.tasks);
    const completedTasks = filter((t_2) => (t_2.Finished != null), props.tasks);
    const completed = length(completedTasks) | 0;
    const success = length(filter((t_3) => {
        if (t_3.State.tag === 2) {
            return true;
        }
        else {
            return false;
        }
    }, props.tasks)) | 0;
    const failed = length(filter((t_4) => {
        if (t_4.State.tag === 3) {
            return true;
        }
        else {
            return false;
        }
    }, props.tasks)) | 0;
    const timeOpt = map2((start, finished) => op_Subtraction(finished, start), (matchValue_3 = choose((t_5) => t_5.Started, props.tasks), isEmpty(matchValue_3) ? undefined : min(matchValue_3, {
        Compare: compare,
    })), (matchValue_4 = choose((t_6) => t_6.Finished, props.tasks), isEmpty(matchValue_4) ? undefined : max(matchValue_4, {
        Compare: compare,
    })));
    return createElement("div", createObj(Helpers_combineClasses("modal", ofArray([["className", "is-active"], (elems_13 = [createElement("div", createObj(Helpers_combineClasses("modal-background", empty()))), (elms_7 = ofArray([(elms = ofArray([createElement("p", {
        className: "modal-card-title",
        children: props.title,
    }), createElement("button", createObj(Helpers_combineClasses("delete", singleton_1(["onClick", (_arg) => {
        if (allFinished ? true : isEmpty(props.tasks)) {
            props.close(success > 0);
        }
    }]))))]), createElement("header", {
        className: "modal-card-head",
        children: reactApi.Children.toArray(Array.from(elms)),
    })), (elms_5 = toList(delay(() => {
        let elems_9, elms_1, elems_1, elms_2, elems_3, elms_3, elems_5, elms_4, elems_7;
        return append(started ? singleton(createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "is-grouped"], ["className", "is-grouped-multiline"], (elems_9 = [(elms_1 = singleton_1(createElement("div", createObj(Helpers_combineClasses("tags", ofArray([["className", "has-addons"], (elems_1 = [createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-dark"], ["children", "Tasks/Complete"]])))), createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-primary"], ["children", `${System_Int32__Int32_ToLocaleString(length(props.tasks))}/${System_Int32__Int32_ToLocaleString(completed)}`]]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_2 = singleton_1(createElement("div", createObj(Helpers_combineClasses("tags", ofArray([["className", "has-addons"], (elems_3 = [createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-dark"], ["children", "Success"]])))), createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-success"], ["children", `${System_Int32__Int32_ToLocaleString(success)}`]]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        })), (elms_3 = singleton_1(createElement("div", createObj(Helpers_combineClasses("tags", ofArray([["className", "has-addons"], (elems_5 = [createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-dark"], ["children", "Failed"]])))), createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-danger"], ["children", `${System_Int32__Int32_ToLocaleString(failed)}`]]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        })), (elms_4 = singleton_1(createElement("div", createObj(Helpers_combineClasses("tags", ofArray([["className", "has-addons"], (elems_7 = [createElement("span", createObj(Helpers_combineClasses("tag", ofArray([["className", "is-dark"], ["children", "Time"]])))), createElement("span", createObj(Helpers_combineClasses("tag", toList(delay(() => append(singleton(["className", "is-info"]), delay(() => {
            const matchValue_5 = timeOpt;
            return (matchValue_5 != null) ? singleton(["children", Humanize_timeSpan(matchValue_5)]) : singleton(["children", "..."]);
        })))))))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_4)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))))) : empty_1(), delay(() => append((!started && !allFinished) ? singleton(props.content) : empty_1(), delay(() => {
            let children_5;
            return singleton((children_5 = map_1((task) => createElement("li", {
                key: task.Id,
                children: Modal_taskOutput(task),
            }), completedTasks), createElement("ul", {
                children: reactApi.Children.toArray(Array.from(children_5)),
            })));
        }))));
    })), createElement("section", {
        className: "modal-card-body",
        children: reactApi.Children.toArray(Array.from(elms_5)),
    })), (elms_6 = toList(delay(() => (started ? singleton(createElement("progress", createObj(Helpers_combineClasses("progress", toList(delay(() => append(singleton(["className", "is-small"]), delay(() => append(singleton(["value", completed]), delay(() => append(singleton(["max", length(props.tasks)]), delay(() => ((completed > success) ? singleton(["className", "is-danger"]) : (((completed > 0) && (success !== completed)) ? singleton(["className", "is-warning"]) : singleton(["className", "is-primary"]))))))))))))))) : singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-primary"], ["children", props.submitText], ["onClick", (_arg_1) => {
        props.submit();
    }]])))))))), createElement("footer", {
        className: "modal-card-foot",
        children: reactApi.Children.toArray(Array.from(elms_6)),
    }))]), createElement("div", {
        className: "modal-card",
        children: reactApi.Children.toArray(Array.from(elms_7)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_13))])]))));
}

export function Components_FetchErrorNotification(components_FetchErrorNotificationInputProps) {
    const error = components_FetchErrorNotificationInputProps.error;
    const patternInput = reactApi.useState("");
    const setMessage = patternInput[1];
    reactApi.useEffect(() => {
        switch (error.tag) {
            case 1: {
                setMessage("Did not understand the response from the server");
                break;
            }
            case 0: {
                setMessage("Failed to talk to server");
                break;
            }
            case 2: {
                const e = error.fields[0];
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Fetch_Types_Response__Response_ProblemDetails(e).then((_arg) => {
                    const response = _arg;
                    if (response == null) {
                        setMessage(e.statusText);
                        return Promise.resolve();
                    }
                    else {
                        const pd = response;
                        const matchValue = pd.Detail;
                        if (matchValue != null) {
                            setMessage(`${pd.Title} : ${matchValue}`);
                            return Promise.resolve();
                        }
                        else {
                            setMessage(pd.Title);
                            return Promise.resolve();
                        }
                    }
                }))));
                void pr;
                break;
            }
            default:
                setMessage("Error with the network");
        }
    }, []);
    return createElement("div", createObj(Helpers_combineClasses("notification", ofArray([["className", "is-danger"], ["children", patternInput[0]]]))));
}

export function Components_Delete(components_DeleteInputProps) {
    let xs_8, elms_1, elms, children_2;
    const close = components_DeleteInputProps.close;
    const entities = components_DeleteInputProps.entities;
    const projectId = components_DeleteInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const reason = patternInput_1[0];
    let delete$;
    const dependencies_1 = [entities, reason];
    delete$ = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const reason_2 = new DeleteEntity(reason);
            return PromiseBuilder__For_1565554B(promise, entities, (_arg) => {
                const entity = _arg;
                const entityId = DomainEntity__get_Id(entity);
                taskDispatch(new TaskMsg(0, [entityId, `Delete ${DomainEntity__get_Name(entity)}`]));
                taskDispatch(new TaskMsg(2, [entityId]));
                return ((entity.tag === 0) ? delete$_1(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 1) ? delete$_2(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 2) ? delete$_3(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 3) ? delete$_4(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 4) ? delete$_5(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 5) ? delete$_6(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 6) ? delete$_7(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 7) ? delete$_8(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 8) ? delete$_9(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 9) ? delete$_10(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 10) ? delete$_11(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 12) ? delete$_12(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 13) ? delete$_13(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 14) ? delete$_14(projectId, DomainEntity__get_Id(entity), reason_2) : delete$_15(projectId, DomainEntity__get_Id(entity), reason_2))))))))))))))).then((_arg_1) => {
                    const result = _arg_1;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(4, [DomainEntity__get_Id(entity), Thoth_Fetch_FetchError__FetchError_get_Message(result.fields[0])]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [DomainEntity__get_Id(entity), undefined]));
                        return Promise.resolve();
                    }
                });
            });
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_8 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Reason Why",
        }), (elms = singleton_1(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            const reason_1 = ev.target.value;
            patternInput_1[1](isNullOrWhiteSpace(reason_1) ? undefined : reason_1);
        }], ["defaultValue", defaultArg(reason, "")]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), createElement("p", {
            className: "",
            children: "Are you sure you want to delete the following:",
        }), (children_2 = map_1((entity_1) => {
            const matchValue = DomainEntity__get_Detail(entity_1);
            if (matchValue == null) {
                return createElement("p", {
                    className: "",
                    children: DomainEntity__get_Name(entity_1),
                });
            }
            else {
                const detail = matchValue;
                return createElement("p", {
                    className: "",
                    children: `${DomainEntity__get_Name(entity_1)} (${detail})`,
                });
            }
        }, entities), createElement("ul", {
            children: reactApi.Children.toArray(Array.from(children_2)),
        }))], react.createElement(react.Fragment, {}, ...xs_8)),
        submit: delete$,
        submitText: "Delete",
        tasks: patternInput[0],
        title: "Delete",
    });
}

export function Components_UnDelete(components_UnDeleteInputProps) {
    let xs_8, elms_1, elms, children_2;
    const close = components_UnDeleteInputProps.close;
    const entities = components_UnDeleteInputProps.entities;
    const projectId = components_UnDeleteInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const reason = patternInput_1[0];
    let delete$;
    const dependencies_1 = [entities];
    delete$ = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            const reason_2 = new DeleteEntity(reason);
            return PromiseBuilder__For_1565554B(promise, entities, (_arg) => {
                const entity = _arg;
                taskDispatch(new TaskMsg(0, [DomainEntity__get_Id(entity), `UnDelete ${DomainEntity__get_Name(entity)}`]));
                taskDispatch(new TaskMsg(2, [DomainEntity__get_Id(entity)]));
                return ((entity.tag === 0) ? undelete(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 1) ? undelete_1(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 2) ? undelete_2(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 3) ? undelete_3(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 4) ? undelete_4(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 5) ? undelete_5(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 6) ? undelete_6(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 7) ? undelete_7(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 8) ? undelete_8(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 9) ? undelete_9(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 10) ? undelete_10(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 12) ? undelete_11(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 13) ? undelete_12(projectId, DomainEntity__get_Id(entity), reason_2) : ((entity.tag === 14) ? undelete_13(projectId, DomainEntity__get_Id(entity), reason_2) : undelete_14(projectId, DomainEntity__get_Id(entity), reason_2))))))))))))))).then((_arg_1) => {
                    const result = _arg_1;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(4, [DomainEntity__get_Id(entity), Thoth_Fetch_FetchError__FetchError_get_Message(result.fields[0])]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [DomainEntity__get_Id(entity), undefined]));
                        return Promise.resolve();
                    }
                });
            });
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_8 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Reason Why",
        }), (elms = singleton_1(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            const reason_1 = ev.target.value;
            patternInput_1[1](isNullOrWhiteSpace(reason_1) ? undefined : reason_1);
        }], ["defaultValue", defaultArg(reason, "")]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), createElement("p", {
            className: "",
            children: "Are you sure you want to undelete the following:",
        }), (children_2 = map_1((entity_1) => {
            const matchValue = DomainEntity__get_Detail(entity_1);
            if (matchValue == null) {
                return createElement("p", {
                    className: "",
                    children: DomainEntity__get_Name(entity_1),
                });
            }
            else {
                const detail = matchValue;
                return createElement("p", {
                    className: "",
                    children: `${DomainEntity__get_Name(entity_1)} (${detail})`,
                });
            }
        }, entities), createElement("ul", {
            children: reactApi.Children.toArray(Array.from(children_2)),
        }))], react.createElement(react.Fragment, {}, ...xs_8)),
        submit: delete$,
        submitText: "Delete",
        tasks: patternInput[0],
        title: "Delete",
    });
}

class Components_LabelState extends Record {
    constructor(Labels) {
        super();
        this.Labels = Labels;
    }
}

function Components_LabelState_$reflection() {
    return record_type("EPM.App.Modals.Components.LabelState", [], Components_LabelState, () => [["Labels", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [tuple_type(string_type, string_type)])]]);
}

class Components_LabelMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddLabel", "RemoveLabel"];
    }
}

function Components_LabelMsg_$reflection() {
    return union_type("EPM.App.Modals.Components.LabelMsg", [], Components_LabelMsg, () => [[["Item1", string_type], ["Item2", string_type]], [["Item1", string_type], ["Item2", string_type]]]);
}

function Components_initLabel(existingLabels) {
    return [new Components_LabelState(existingLabels), Cmd_none()];
}

function Components_updateLabel(msg, state) {
    if (msg.tag === 1) {
        return [new Components_LabelState(remove([msg.fields[0], msg.fields[1]], state.Labels)), Cmd_none()];
    }
    else {
        return [new Components_LabelState(add([msg.fields[0], msg.fields[1]], state.Labels)), Cmd_none()];
    }
}

export function Components_ChangeLabels(components_ChangeLabelsInputProps) {
    let list_1, xs_31, elems_1, children_2, children, children_6, elems_3, children_10, children_8, children_14, elems_7, elms, elms_1, elms_2;
    const close = components_ChangeLabelsInputProps.close;
    const entities = components_ChangeLabelsInputProps.entities;
    const projectId = components_ChangeLabelsInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const setKey = patternInput_1[1];
    const keyText = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const valueText = patternInput_2[0];
    const setValue = patternInput_2[1];
    let allExistingLabels;
    const dependencies_1 = [entities];
    allExistingLabels = reactApi.useMemo(() => ofSeq(collect((m) => collect((kv) => map_2((v) => [kv[0], v], kv[1]), m), map_2((tuple) => tuple[1], entities)), {
        Compare: compareArrays,
    }), dependencies_1);
    let commonLabels;
    const dependencies_1_1 = [entities];
    commonLabels = reactApi.useMemo(() => intersectMany(map_2((m_1) => ofSeq(collect((kv_1) => map_2((v_1) => [kv_1[0], v_1], kv_1[1]), m_1), {
        Compare: compareArrays,
    }), map_2((tuple_1) => tuple_1[1], entities))), dependencies_1_1);
    let patternInput_3;
    const init = Components_initLabel(commonLabels);
    patternInput_3 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, Components_updateLabel, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput_3[0];
    const dispatch = patternInput_3[1];
    let missing;
    const dependencies_1_2 = [commonLabels, state_1.Labels];
    missing = reactApi.useMemo(() => difference(commonLabels, state_1.Labels), dependencies_1_2);
    let patternInput_4;
    const dependencies_1_3 = [commonLabels, state_1.Labels];
    patternInput_4 = reactApi.useMemo(() => partition((tupledArg) => !FSharpSet__Contains(commonLabels, [tupledArg[0], tupledArg[1]]), state_1.Labels), dependencies_1_3);
    const newLabels = patternInput_4[0];
    const commonExistingLabels = sort((list_1 = ofSeq_1(patternInput_4[1]), append_1(ofSeq_1(missing), list_1)), {
        Compare: compareArrays,
    });
    let changeLabels;
    const dependencies_1_4 = [entities, missing, newLabels];
    changeLabels = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => PromiseBuilder__For_1565554B(promise, entities, (_arg_2) => {
            const entity = _arg_2[0];
            const labels_1 = new ChangeLabels(ofSeq_2(map_2((tupledArg_1) => [tupledArg_1[0], ofSeq(map_2((tuple_3) => tuple_3[1], tupledArg_1[1]), {
                Compare: comparePrimitives,
            })], groupBy((tuple_2) => tuple_2[0], union(newLabels, filter_1((arg) => !FSharpSet__Contains(missing, arg), ofSeq(collect((kv_2) => map_2((v_2) => [kv_2[0], v_2], kv_2[1]), _arg_2[1]), {
                Compare: compareArrays,
            }))), {
                Equals: (x_4, y_4) => (x_4 === y_4),
                GetHashCode: stringHash,
            })), {
                Compare: comparePrimitives,
            }));
            taskDispatch(new TaskMsg(0, [DomainEntity__get_Id(entity), `Adding Labels for ${DomainEntity__get_Name(entity)}`]));
            taskDispatch(new TaskMsg(2, [DomainEntity__get_Id(entity)]));
            let result;
            switch (entity.tag) {
                case 0: {
                    result = changeLabels_1(projectId, DomainEntity__get_Id(entity), labels_1);
                    break;
                }
                case 1: {
                    result = changeLabels_2(projectId, DomainEntity__get_Id(entity), labels_1);
                    break;
                }
                case 2: {
                    result = changeLabels_3(projectId, DomainEntity__get_Id(entity), labels_1);
                    break;
                }
                case 3: {
                    result = changeLabels_4(projectId, DomainEntity__get_Id(entity), labels_1);
                    break;
                }
                case 4: {
                    const a = new FSharpResult$2(1, [new FetchError(0, [new Error(`Production Unit Type: ${entity.fields[0].Name} does not support labels`)])]);
                    result = (Promise.resolve(a));
                    break;
                }
                case 5: {
                    result = changeLabels_5(projectId, DomainEntity__get_Id(entity), labels_1);
                    break;
                }
                case 6: {
                    result = changeLabels_6(projectId, DomainEntity__get_Id(entity), labels_1);
                    break;
                }
                case 7: {
                    result = changeLabels_7(projectId, DomainEntity__get_Id(entity), labels_1);
                    break;
                }
                case 8: {
                    result = changeLabels_8(projectId, DomainEntity__get_Id(entity), labels_1);
                    break;
                }
                case 9: {
                    result = changeLabels_9(projectId, DomainEntity__get_Id(entity), labels_1);
                    break;
                }
                case 10: {
                    const a_1 = new FSharpResult$2(1, [new FetchError(0, [new Error(`Action Type: ${entity.fields[0].Name} does not support labels`)])]);
                    result = (Promise.resolve(a_1));
                    break;
                }
                case 12: {
                    result = changeLabels_10(projectId, DomainEntity__get_Id(entity), labels_1);
                    break;
                }
                case 13: {
                    const a_2 = new FSharpResult$2(1, [new FetchError(0, [new Error(`Discipline: ${entity.fields[0].Name} does not support labels`)])]);
                    result = (Promise.resolve(a_2));
                    break;
                }
                case 14: {
                    const a_3 = new FSharpResult$2(1, [new FetchError(0, [new Error(`Equipment Type: ${entity.fields[0].Name} does not support labels`)])]);
                    result = (Promise.resolve(a_3));
                    break;
                }
                default:
                    result = changeLabels_11(projectId, DomainEntity__get_Id(entity), labels_1);
            }
            return result.then((_arg_3) => {
                if (_arg_3.tag === 1) {
                    taskDispatch(new TaskMsg(4, [DomainEntity__get_Id(entity), Thoth_Fetch_FetchError__FetchError_get_Message(_arg_3.fields[0])]));
                    return Promise.resolve();
                }
                else {
                    taskDispatch(new TaskMsg(3, [DomainEntity__get_Id(entity), undefined]));
                    return Promise.resolve();
                }
            });
        })));
        void pr;
    }, dependencies_1_4);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_31 = [createElement("h4", {
            className: "title is-4",
            children: "Existing Labels",
        }), createElement("table", createObj(Helpers_combineClasses("table", ofArray([["className", "is-fullwidth"], ["className", "is-bordered"], (elems_1 = [(children_2 = singleton_1((children = ofArray([createElement("th", {}), createElement("th", {
            children: ["Key"],
        }), createElement("th", {
            children: ["Value"],
        }), createElement("th", {
            children: ["Remove"],
        })]), createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children)),
        }))), createElement("thead", {
            children: reactApi.Children.toArray(Array.from(children_2)),
        })), (children_6 = toList(delay(() => map_1((tupledArg_2) => {
            let elems, children_4;
            const label = tupledArg_2[0];
            const value_16 = tupledArg_2[1];
            return createElement("tr", createObj(ofArray([["key", `${label}${value_16}`], (elems = [(children_4 = toList(delay(() => (FSharpSet__Contains(missing, [label, value_16]) ? singleton(createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "has-text-warning"], ["title", "This label will be removed from all items selected"], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-exclamation-triangle"])), [])]]))))) : empty_1()))), createElement("th", {
                children: reactApi.Children.toArray(Array.from(children_4)),
            })), createElement("td", {
                children: [label],
            }), createElement("td", {
                children: [value_16],
            }), createElement("td", {
                children: [FSharpSet__Contains(missing, [label, value_16]) ? createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "has-text-success"], ["className", "is-clickable"], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-plus-circle"])), [])], ["onClick", (_arg_4) => {
                    dispatch(new Components_LabelMsg(0, [label, value_16]));
                }]])))) : createElement("button", createObj(Helpers_combineClasses("delete", singleton_1(["onClick", (_arg_5) => {
                    dispatch(new Components_LabelMsg(1, [label, value_16]));
                }]))))],
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }, commonExistingLabels))), createElement("tbody", {
            children: reactApi.Children.toArray(Array.from(children_6)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), createElement("h4", {
            className: "title is-4",
            children: "New Labels",
        }), createElement("table", createObj(Helpers_combineClasses("table", ofArray([["className", "is-fullwidth"], ["className", "is-bordered"], (elems_3 = [(children_10 = singleton_1((children_8 = ofArray([createElement("th", {}), createElement("th", {
            children: ["Key"],
        }), createElement("th", {
            children: ["Value"],
        }), createElement("th", {
            children: ["Remove"],
        })]), createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children_8)),
        }))), createElement("thead", {
            children: reactApi.Children.toArray(Array.from(children_10)),
        })), (children_14 = toList(delay(() => map_2((tupledArg_3) => {
            let elems_2, children_12;
            const label_1 = tupledArg_3[0];
            const value_50 = tupledArg_3[1];
            return createElement("tr", createObj(ofArray([["key", `${label_1}${value_50}`], (elems_2 = [(children_12 = toList(delay(() => (FSharpSet__Contains(allExistingLabels, [label_1, value_50]) ? singleton(createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "has-text-info"], ["title", "This label exists on some of the items you\'ve selected"], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-info-circle"])), [])]]))))) : empty_1()))), createElement("td", {
                children: reactApi.Children.toArray(Array.from(children_12)),
            })), createElement("td", {
                children: [label_1],
            }), createElement("td", {
                children: [value_50],
            }), createElement("td", {
                children: [createElement("button", createObj(Helpers_combineClasses("delete", singleton_1(["onClick", (_arg_6) => {
                    dispatch(new Components_LabelMsg(1, [label_1, value_50]));
                }]))))],
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
        }, newLabels))), createElement("tbody", {
            children: reactApi.Children.toArray(Array.from(children_14)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "has-addons"], (elems_7 = [(elms = singleton_1(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["placeholder", "Label"], ["maxLength", 250], ["value", keyText], ["onChange", (ev) => {
            setKey(ev.target.value);
        }]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        })), (elms_1 = singleton_1(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["placeholder", "Value"], ["maxLength", 250], ["value", valueText], ["onChange", (ev_1) => {
            setValue(ev_1.target.value);
        }]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_2 = singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["children", "Add"], ["className", "is-info"], ["onClick", (_arg_7) => {
            dispatch(new Components_LabelMsg(0, [keyText, valueText]));
            setKey("");
            setValue("");
        }]]))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))))], react.createElement(react.Fragment, {}, ...xs_31)),
        submit: changeLabels,
        submitText: "Change",
        tasks: patternInput[0],
        title: "Change Labels",
    });
}

class Components_AttributeState extends Record {
    constructor(Attributes) {
        super();
        this.Attributes = Attributes;
    }
}

function Components_AttributeState_$reflection() {
    return record_type("EPM.App.Modals.Components.AttributeState", [], Components_AttributeState, () => [["Attributes", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [tuple_type(string_type, Attribute_$reflection())])]]);
}

class Components_AttributeMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AddAttribute", "RemoveAttribute"];
    }
}

function Components_AttributeMsg_$reflection() {
    return union_type("EPM.App.Modals.Components.AttributeMsg", [], Components_AttributeMsg, () => [[["Item1", string_type], ["Item2", Attribute_$reflection()]], [["Item1", string_type], ["Item2", Attribute_$reflection()]]]);
}

function Components_initAttribute(existingAttributes) {
    return [new Components_AttributeState(existingAttributes), Cmd_none()];
}

function Components_updateAttribute(msg, state) {
    if (msg.tag === 1) {
        return [new Components_AttributeState(remove([msg.fields[0], msg.fields[1]], state.Attributes)), Cmd_none()];
    }
    else {
        return [new Components_AttributeState(add([msg.fields[0], msg.fields[1]], state.Attributes)), Cmd_none()];
    }
}

function Components_renderAttrribute(attribute) {
    if (attribute.tag === 1) {
        return attribute.fields[0];
    }
    else {
        return attribute.fields[0];
    }
}

function Components_renderAttrributeType(attribute) {
    if (attribute.tag === 1) {
        return "Number";
    }
    else {
        return "Text";
    }
}

function Components_parseAttribute(x) {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(x, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return new Attribute(1, [matchValue[1]]);
    }
    else {
        return new Attribute(0, [x]);
    }
}

export function Components_ChangeAttributes(components_ChangeAttributesInputProps) {
    let list_1, xs_31, elems_1, children_2, children, children_6, elems_3, children_10, children_8, children_14, elems_7, elms, elms_1, elms_2;
    const close = components_ChangeAttributesInputProps.close;
    const entities = components_ChangeAttributesInputProps.entities;
    const projectId = components_ChangeAttributesInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const setKey = patternInput_1[1];
    const keyText = patternInput_1[0];
    const patternInput_2 = reactApi.useState("");
    const valueText = patternInput_2[0];
    const setValue = patternInput_2[1];
    let allExistingAttributes;
    const dependencies_1 = [entities];
    allExistingAttributes = reactApi.useMemo(() => unionMany(map_2((m) => ofSeq(map_2((kv) => [kv[0], kv[1]], m), {
        Compare: compareArrays,
    }), map_2((tuple) => tuple[1], entities)), {
        Compare: compareArrays,
    }), dependencies_1);
    let commonAttributes;
    const dependencies_1_1 = [entities];
    commonAttributes = reactApi.useMemo(() => intersectMany(map_2((m_1) => ofSeq(map_2((kv_1) => [kv_1[0], kv_1[1]], m_1), {
        Compare: compareArrays,
    }), map_2((tuple_1) => tuple_1[1], entities))), dependencies_1_1);
    let patternInput_3;
    const init = Components_initAttribute(commonAttributes);
    patternInput_3 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, Components_updateAttribute, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput_3[0];
    const dispatch = patternInput_3[1];
    let missing;
    const dependencies_1_2 = [commonAttributes, state_1.Attributes];
    missing = reactApi.useMemo(() => difference(commonAttributes, state_1.Attributes), dependencies_1_2);
    let patternInput_4;
    const dependencies_1_3 = [commonAttributes, state_1.Attributes];
    patternInput_4 = reactApi.useMemo(() => partition((tupledArg) => !FSharpSet__Contains(commonAttributes, [tupledArg[0], tupledArg[1]]), state_1.Attributes), dependencies_1_3);
    const newAttributes = patternInput_4[0];
    const commonExistingAttributes = sort((list_1 = ofSeq_1(patternInput_4[1]), append_1(ofSeq_1(missing), list_1)), {
        Compare: compareArrays,
    });
    let changeLabels;
    const dependencies_1_4 = [entities, missing, newAttributes];
    changeLabels = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => PromiseBuilder__For_1565554B(promise, entities, (_arg_2) => {
            let a, a_1, a_2;
            const entity = _arg_2[0];
            const attributes_1 = new ChangeAttributes(ofSeq_2(union(newAttributes, filter_1((arg) => !FSharpSet__Contains(missing, arg), ofSeq(map_2((kv_2) => [kv_2[0], kv_2[1]], _arg_2[1]), {
                Compare: compareArrays,
            }))), {
                Compare: comparePrimitives,
            }));
            taskDispatch(new TaskMsg(0, [Entity__get_Id(entity), `Adding Attributes for ${Entity__get_Name(entity)}`]));
            taskDispatch(new TaskMsg(2, [Entity__get_Id(entity)]));
            return ((entity.tag === 1) ? changeAttributes(projectId, Entity__get_Id(entity), attributes_1) : ((entity.tag === 2) ? changeAttributes_1(projectId, Entity__get_Id(entity), attributes_1) : ((entity.tag === 3) ? changeAttributes_2(projectId, Entity__get_Id(entity), attributes_1) : ((entity.tag === 4) ? changeAttributes_3(projectId, Entity__get_Id(entity), attributes_1) : ((entity.tag === 5) ? changeAttributes_4(projectId, Entity__get_Id(entity), attributes_1) : ((entity.tag === 6) ? changeAttributes_5(projectId, Entity__get_Id(entity), attributes_1) : ((entity.tag === 7) ? changeAttributes_6(projectId, Entity__get_Id(entity), attributes_1) : ((entity.tag === 8) ? ((a = (new FSharpResult$2(1, [new FetchError(0, [new Error(`Document: ${entity.fields[0].Name} does not support attributes`)])])), Promise.resolve(a))) : ((entity.tag === 10) ? ((a_1 = (new FSharpResult$2(1, [new FetchError(0, [new Error(`Activity: ${entity.fields[1].Name} does not support attributes`)])])), Promise.resolve(a_1))) : ((entity.tag === 9) ? ((a_2 = (new FSharpResult$2(1, [new FetchError(0, [new Error(`Document: ${entity.fields[0].Name} does not support attributes`)])])), Promise.resolve(a_2))) : changeAttributes_7(projectId, Entity__get_Id(entity), attributes_1))))))))))).then((_arg_3) => {
                const result = _arg_3;
                if (result.tag === 1) {
                    taskDispatch(new TaskMsg(4, [Entity__get_Id(entity), Thoth_Fetch_FetchError__FetchError_get_Message(result.fields[0])]));
                    return Promise.resolve();
                }
                else {
                    taskDispatch(new TaskMsg(3, [Entity__get_Id(entity), undefined]));
                    return Promise.resolve();
                }
            });
        })));
        void pr;
    }, dependencies_1_4);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_31 = [createElement("h4", {
            className: "title is-4",
            children: "Existing Attributes",
        }), createElement("table", createObj(Helpers_combineClasses("table", ofArray([["className", "is-fullwidth"], ["className", "is-bordered"], (elems_1 = [(children_2 = singleton_1((children = ofArray([createElement("th", {}), createElement("th", {
            children: ["Key"],
        }), createElement("th", {
            children: ["Attribute"],
        }), createElement("th", {
            children: ["Type"],
        }), createElement("th", {
            children: ["Remove"],
        })]), createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children)),
        }))), createElement("thead", {
            children: reactApi.Children.toArray(Array.from(children_2)),
        })), (children_6 = toList(delay(() => map_1((tupledArg_1) => {
            let elems, children_4;
            const label = tupledArg_1[0];
            const attribute = tupledArg_1[1];
            return createElement("tr", createObj(ofArray([["key", `${label}${attribute}`], (elems = [(children_4 = toList(delay(() => (FSharpSet__Contains(missing, [label, attribute]) ? singleton(createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "has-text-warning"], ["title", "This attributes will be removed from all items selected"], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-exclamation-triangle"])), [])]]))))) : empty_1()))), createElement("th", {
                children: reactApi.Children.toArray(Array.from(children_4)),
            })), createElement("td", {
                children: [label],
            }), createElement("td", {
                children: [Components_renderAttrribute(attribute)],
            }), createElement("td", {
                children: [Components_renderAttrributeType(attribute)],
            }), createElement("td", {
                children: [FSharpSet__Contains(missing, [label, attribute]) ? createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "has-text-success"], ["className", "is-clickable"], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-plus-circle"])), [])], ["onClick", (_arg_4) => {
                    dispatch(new Components_AttributeMsg(0, [label, attribute]));
                }]])))) : createElement("button", createObj(Helpers_combineClasses("delete", singleton_1(["onClick", (_arg_5) => {
                    dispatch(new Components_AttributeMsg(1, [label, attribute]));
                }]))))],
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }, commonExistingAttributes))), createElement("tbody", {
            children: reactApi.Children.toArray(Array.from(children_6)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), createElement("h4", {
            className: "title is-4",
            children: "New Attributes",
        }), createElement("table", createObj(Helpers_combineClasses("table", ofArray([["className", "is-fullwidth"], ["className", "is-bordered"], (elems_3 = [(children_10 = singleton_1((children_8 = ofArray([createElement("th", {}), createElement("th", {
            children: ["Key"],
        }), createElement("th", {
            children: ["Attribute"],
        }), createElement("th", {
            children: ["Type"],
        }), createElement("th", {
            children: ["Remove"],
        })]), createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children_8)),
        }))), createElement("thead", {
            children: reactApi.Children.toArray(Array.from(children_10)),
        })), (children_14 = toList(delay(() => map_2((tupledArg_2) => {
            let elems_2, children_12;
            const label_1 = tupledArg_2[0];
            const attribute_1 = tupledArg_2[1];
            return createElement("tr", createObj(ofArray([["key", `${label_1}${attribute_1}`], (elems_2 = [(children_12 = toList(delay(() => (FSharpSet__Contains(allExistingAttributes, [label_1, attribute_1]) ? singleton(createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "has-text-info"], ["title", "This attribute exists on some of the items you\'ve selected"], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-info-circle"])), [])]]))))) : empty_1()))), createElement("td", {
                children: reactApi.Children.toArray(Array.from(children_12)),
            })), createElement("td", {
                children: [label_1],
            }), createElement("td", {
                children: [Components_renderAttrribute(attribute_1)],
            }), createElement("td", {
                children: [Components_renderAttrributeType(attribute_1)],
            }), createElement("td", {
                children: [createElement("button", createObj(Helpers_combineClasses("delete", singleton_1(["onClick", (_arg_6) => {
                    dispatch(new Components_AttributeMsg(1, [label_1, attribute_1]));
                }]))))],
            })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
        }, newAttributes))), createElement("tbody", {
            children: reactApi.Children.toArray(Array.from(children_14)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "has-addons"], (elems_7 = [(elms = singleton_1(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["placeholder", "Label"], ["value", keyText], ["onChange", (ev) => {
            setKey(ev.target.value);
        }]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        })), (elms_1 = singleton_1(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["placeholder", "Attribute"], ["value", valueText], ["onChange", (ev_1) => {
            setValue(ev_1.target.value);
        }]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        })), (elms_2 = singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["children", "Add"], ["className", "is-info"], ["onClick", (_arg_7) => {
            dispatch(new Components_AttributeMsg(0, [keyText, Components_parseAttribute(valueText)]));
            setKey("");
            setValue("");
        }]]))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])]))))], react.createElement(react.Fragment, {}, ...xs_31)),
        submit: changeLabels,
        submitText: "Change",
        tasks: patternInput[0],
        title: "Change Attributes",
    });
}

const Components_exportLabelsHeaders = ofArray([{
    key: "id",
    name: "Id",
}, {
    key: "entityType",
    name: "Type",
}, {
    key: "name",
    name: "Name",
}]);

function Components_exportLabels(entity) {
    let list_1, copyOfStruct;
    return ofList((list_1 = ofArray([["id", (copyOfStruct = DomainEntity__get_Id(entity), copyOfStruct)], ["entityType", toString(DomainEntity__get_DomainEntity(entity))], ["name", DomainEntity__get_Name(entity)]]), append_1(ofSeq_1(collect((kv) => collect((x) => x, mapIndexed((i, v) => singleton_1([`Label:${kv[0]}:${i}`, v]), kv[1])), DomainEntity__get_Labels(entity))), list_1)), {
        Compare: comparePrimitives,
    });
}

function Components_downloadLabelsCSV(entityType, setProcessing, setTotal, setFetched, countApi, entitiesApi) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        setProcessing(true);
        return countApi().then((_arg) => {
            let initialCount, labelHeaders, chunks;
            const initialCountResult = _arg;
            let results = empty();
            let fetchedCount = 0;
            return ((initialCountResult.tag === 0) ? ((initialCount = (initialCountResult.fields[0] | 0), (setTotal(initialCount), (labelHeaders = empty_2({
                Compare: compare_1,
            }), (chunks = ((~~(initialCount / 100) + (((initialCount % 100) > 0) ? 1 : 0)) | 0), PromiseBuilder__For_1565554B(promise, rangeDouble(0, 1, chunks - 1), (_arg_1) => {
                const apiParams = ofArray([["fetch", int32ToString(100)], ["offset", int32ToString(_arg_1 * 100)]]);
                return entitiesApi(apiParams).then((_arg_2) => {
                    const dataResult = _arg_2;
                    if (dataResult.tag === 0) {
                        const entities = dataResult.fields[0];
                        const entityLabelHeaders = ofSeq(collect((entity) => collect((tupledArg) => {
                            const key = tupledArg[0];
                            return map_1((n_1) => ({
                                key: `Label:${key}:${n_1}`,
                                name: `Label:${key}`,
                            }), toList(rangeDouble(0, 1, length_1(tupledArg[1]) - 1)));
                        }, groupBy((x_1) => x_1, map_2((kv) => kv[0], DomainEntity__get_Labels(entity)), {
                            Equals: (x_2, y_1) => (x_2 === y_1),
                            GetHashCode: stringHash,
                        })), entities), {
                            Compare: compare_1,
                        });
                        const processedData = map_1(Components_exportLabels, entities);
                        labelHeaders = union(labelHeaders, entityLabelHeaders);
                        results = append_1(processedData, results);
                        fetchedCount = ((fetchedCount + length(entities)) | 0);
                        setFetched(fetchedCount);
                        return Promise.resolve();
                    }
                    else {
                        console.error(some(dataResult.fields[0]));
                        return Promise.resolve();
                    }
                });
            }).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                const processedData_1 = reverse(results);
                const headers = ofSeq_1(append(Components_exportLabelsHeaders, labelHeaders));
                const csv = StringBuilder_$ctor();
                StringBuilder__AppendLine_Z721C83C5(csv, join(",", map_1((header) => Csv_encode(header.name), headers)));
                iterate((arg) => {
                    StringBuilder__AppendLine_Z721C83C5(csv, arg);
                }, map_1((data) => join(",", map_1((header_1) => defaultArg(map(Csv_encode, FSharpMap__TryFind(data, header_1.key)), ""), headers)), processedData_1));
                const content = toString(csv);
                const now = toString_1(utcNow(), "yyyy-MM-dd hh:mm:ss");
                file_saver(new Blob([content], { 'type': "text/csv" }), `${toString(entityType)}-labels-export-${now}.csv`);
                return Promise.resolve();
            }))))))) : ((console.error(some(initialCountResult.fields[0])), Promise.resolve()))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                setProcessing(false);
                return Promise.resolve();
            }));
        });
    }));
    void pr;
}

export function Components_ExportLabels(components_ExportLabelsInputProps) {
    const close = components_ExportLabelsInputProps.close;
    const fetchApi = components_ExportLabelsInputProps.fetchApi;
    const countApi = components_ExportLabelsInputProps.countApi;
    const entityType = components_ExportLabelsInputProps.entityType;
    const patternInput = reactApi.useState(0);
    const total = patternInput[0] | 0;
    const patternInput_1 = reactApi.useState(0);
    const fetched = patternInput_1[0] | 0;
    const patternInput_2 = reactApi.useState(false);
    const processing = patternInput_2[0];
    return createElement(Modal_ModalWithFooter, {
        close: close,
        content: createElement("progress", createObj(Helpers_combineClasses("progress", ofArray([["className", "is-primary"], ["max", total], ["value", fetched], ["title", toText(interpolate("%.2f%P()%%", [(total === 0) ? 0 : ((fetched / total) * 100)]))]])))),
        disabled: processing,
        footer: singleton_1(createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(processing ? singleton(["className", "is-loading"]) : empty_1(), delay(() => append(singleton(["disabled", processing]), delay(() => append(singleton(["children", "Download"]), delay(() => singleton(["onClick", (_arg) => {
            Components_downloadLabelsCSV(entityType, patternInput_2[1], patternInput[1], patternInput_1[1], countApi, fetchApi);
        }]))))))))))))),
        title: "Export Labels as CSV",
    });
}

const Components_VideoFormats = ofArray(["video/webm;codecs=vp9", "video/webm;codecs=daala", "video/webm;codecs=h264", "video/webm", "video/mp4", "video/mpeg"]);

const Components_SupportedVideoFormat = tryFind((mimeType) => (MediaRecorder.isTypeSupported(mimeType)), Components_VideoFormats);

class Components_State extends Record {
    constructor(Devices, CurrentDevice, VideoRef, Stream, IsRecording, Recorder, CaptureKind, PreferedCaptureMethod, PreferedDevice, Attachments) {
        super();
        this.Devices = Devices;
        this.CurrentDevice = CurrentDevice;
        this.VideoRef = VideoRef;
        this.Stream = Stream;
        this.IsRecording = IsRecording;
        this.Recorder = Recorder;
        this.CaptureKind = CaptureKind;
        this.PreferedCaptureMethod = PreferedCaptureMethod;
        this.PreferedDevice = PreferedDevice;
        this.Attachments = Attachments;
    }
}

function Components_State_$reflection() {
    return record_type("EPM.App.Modals.Components.State", [], Components_State, () => [["Devices", list_type(class_type("Browser.Types.MediaDeviceInfo", undefined))], ["CurrentDevice", option_type(class_type("Browser.Types.MediaDeviceInfo", undefined))], ["VideoRef", class_type("Fable.React.IRefValue`1", [option_type(class_type("Browser.Types.HTMLVideoElement\'"))])], ["Stream", option_type(class_type("Browser.Types.MediaStream", undefined))], ["IsRecording", bool_type], ["Recorder", option_type(class_type("Fable.Extras.Media.JSe.MediaRecorder"))], ["CaptureKind", string_type], ["PreferedCaptureMethod", string_type], ["PreferedDevice", string_type], ["Attachments", list_type(tuple_type(class_type("System.Guid"), class_type("Browser.Types.Blob", undefined)))]]);
}

function Components_State__get_CaptureMethod(this$) {
    if (isEmpty(this$.Devices)) {
        return "fileUpload";
    }
    else {
        return this$.PreferedCaptureMethod;
    }
}

class Components_VideoMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["GetDevices", "GotDevices", "ChangeCurrentDevice", "SetupStream", "StreamSetup", "StreamSetupFailed", "CaptureFailed", "TakePicture", "StartRecording", "StopRecording", "StoppedRecording", "Captured", "RemoveAttachment"];
    }
}

function Components_VideoMsg_$reflection() {
    return union_type("EPM.App.Modals.Components.VideoMsg", [], Components_VideoMsg, () => [[], [["Item", list_type(class_type("Browser.Types.MediaDeviceInfo", undefined))]], [["Item", class_type("Browser.Types.MediaDeviceInfo", undefined)]], [], [["Item", class_type("Browser.Types.MediaStream", undefined)]], [], [], [], [["Item", string_type]], [], [["Item", class_type("Browser.Types.Blob", undefined)]], [["Item", list_type(tuple_type(class_type("System.Guid"), class_type("Browser.Types.Blob", undefined)))]], [["Item", class_type("System.Guid")]]]);
}

function Components_getDevices() {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => ((navigator.mediaDevices).enumerateDevices().then((_arg) => {
        const suitableDevices = ofSeq_1(filter_2((device) => (device.kind === "videoinput"), _arg));
        return Promise.resolve(new Components_VideoMsg(1, [suitableDevices]));
    }))));
}

function Components_getStream(captureKind, device, videoRef) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const matchValue = videoRef.current;
        if (matchValue != null) {
            const currentVideo = matchValue;
            const constraints = {
                audio: captureKind === "video",
                video: {
                    deviceId: device.deviceId,
                    height: 2160,
                    width: 4096,
                },
            };
            return (navigator.mediaDevices.getUserMedia(constraints)).then((_arg) => {
                const stream = _arg;
                currentVideo.srcObject = stream;
                currentVideo.play();
                return Promise.resolve(new Components_VideoMsg(4, [stream]));
            });
        }
        else {
            return Promise.resolve(new Components_VideoMsg(5, []));
        }
    }));
}

function Components_takePicture(videoRef) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const matchValue = videoRef.current;
        if (matchValue != null) {
            const video = matchValue;
            const matchValue_1 = video.srcObject;
            if (matchValue_1 != null) {
                const stream = matchValue_1;
                const trackOpt = tryHead(stream.getVideoTracks());
                if (trackOpt != null) {
                    const track = trackOpt;
                    const imageCapture = new ImageCapture(track);
                    return imageCapture.getPhotoCapabilities().then((_arg) => {
                        let imageHeight;
                        const photoCapabilities = _arg;
                        return imageCapture.takePhoto((imageHeight = (photoCapabilities.imageHeight.max | 0), new PhotoSettings(photoCapabilities.imageWidth.max, imageHeight))).then((_arg_1) => (Promise.resolve(new Components_VideoMsg(11, [singleton_1([newGuid(), _arg_1])]))));
                    });
                }
                else {
                    return Promise.resolve(new Components_VideoMsg(6, []));
                }
            }
            else {
                return Promise.resolve(new Components_VideoMsg(6, []));
            }
        }
        else {
            return Promise.resolve(new Components_VideoMsg(6, []));
        }
    }));
}

function Components_update(onAttachmentsChange, msg, state) {
    let matchValue, device_2, msg_3;
    switch (msg.tag) {
        case 1: {
            const devices = msg.fields[0];
            return [new Components_State(devices, orElse(tryFind((device) => (device.label === state.PreferedDevice), devices), tryHead_1(devices)), state.VideoRef, state.Stream, state.IsRecording, state.Recorder, state.CaptureKind, state.PreferedCaptureMethod, state.PreferedDevice, state.Attachments), singleton_1((dispatch) => {
                dispatch(new Components_VideoMsg(3, []));
            })];
        }
        case 2: {
            const device_1 = msg.fields[0];
            return [new Components_State(state.Devices, device_1, state.VideoRef, state.Stream, state.IsRecording, state.Recorder, state.CaptureKind, state.PreferedCaptureMethod, device_1.label, state.Attachments), singleton_1((dispatch_1) => {
                dispatch_1(new Components_VideoMsg(3, []));
            })];
        }
        case 3:
            return [state, (matchValue = state.CurrentDevice, (matchValue != null) ? ((device_2 = matchValue, Cmd_OfPromise_perform(() => Components_getStream(state.CaptureKind, device_2, state.VideoRef), undefined, (x_1) => x_1))) : Cmd_none())];
        case 5:
            return [state, Cmd_none()];
        case 4:
            return [new Components_State(state.Devices, state.CurrentDevice, state.VideoRef, msg.fields[0], state.IsRecording, state.Recorder, state.CaptureKind, state.PreferedCaptureMethod, state.PreferedDevice, state.Attachments), Cmd_none()];
        case 7:
            return [state, Cmd_OfPromise_perform(() => Components_takePicture(state.VideoRef), undefined, (x_2) => x_2)];
        case 11: {
            const newAttachments = append_1(state.Attachments, msg.fields[0]);
            onAttachmentsChange(map_1((tuple) => tuple[1], newAttachments));
            return [new Components_State(state.Devices, state.CurrentDevice, state.VideoRef, state.Stream, state.IsRecording, state.Recorder, state.CaptureKind, state.PreferedCaptureMethod, state.PreferedDevice, newAttachments), Cmd_none()];
        }
        case 6:
            return [state, Cmd_none()];
        case 12: {
            const newAttachments_1 = filter((tupledArg) => (msg.fields[0] !== tupledArg[0]), state.Attachments);
            onAttachmentsChange(map_1((tuple_1) => tuple_1[1], newAttachments_1));
            return [new Components_State(state.Devices, state.CurrentDevice, state.VideoRef, state.Stream, state.IsRecording, state.Recorder, state.CaptureKind, state.PreferedCaptureMethod, state.PreferedDevice, newAttachments_1), Cmd_none()];
        }
        case 8: {
            const matchValue_1 = state.Stream;
            if (matchValue_1 != null) {
                const stream_1 = matchValue_1;
                const recorder = new MediaRecorder(stream_1, {mimeType:msg.fields[0]});
                recorder.start();
                return [new Components_State(state.Devices, state.CurrentDevice, state.VideoRef, state.Stream, true, recorder, state.CaptureKind, state.PreferedCaptureMethod, state.PreferedDevice, state.Attachments), Cmd_none()];
            }
            else {
                return [state, Cmd_none()];
            }
        }
        case 10:
            return [new Components_State(state.Devices, state.CurrentDevice, state.VideoRef, state.Stream, state.IsRecording, undefined, state.CaptureKind, state.PreferedCaptureMethod, state.PreferedDevice, state.Attachments), (msg_3 = (new Components_VideoMsg(11, [singleton_1([newGuid(), msg.fields[0]])])), singleton_1((dispatch_2) => {
                dispatch_2(msg_3);
            }))];
        case 9: {
            const matchValue_2 = state.Recorder;
            if (matchValue_2 != null) {
                const recorder_1 = matchValue_2;
                const cmd_1 = Cmd_ofEffect((dispatch_3) => {
                    recorder_1.ondataavailable = ((e) => {
                        dispatch_3(new Components_VideoMsg(10, [e.data]));
                    });
                });
                recorder_1.stop();
                return [new Components_State(state.Devices, state.CurrentDevice, state.VideoRef, state.Stream, false, state.Recorder, state.CaptureKind, state.PreferedCaptureMethod, state.PreferedDevice, state.Attachments), cmd_1];
            }
            else {
                return [state, Cmd_none()];
            }
        }
        default:
            return [state, Cmd_OfPromise_perform(Components_getDevices, undefined, (x) => x)];
    }
}

function Components_init(preferedFileCapture, preferedDevice, videoRef, captureKind) {
    return [new Components_State(empty(), undefined, videoRef, undefined, false, undefined, captureKind, preferedFileCapture ? "fileUpload" : "device", preferedDevice, empty()), singleton_1((dispatch) => {
        dispatch(new Components_VideoMsg(0, []));
    })];
}

export function Components_VideoFeed(components_VideoFeedInputProps) {
    let elems_8;
    const onAttachmentsChange = components_VideoFeedInputProps.onAttachmentsChange;
    const disabled = components_VideoFeedInputProps.disabled;
    const captureKind = components_VideoFeedInputProps.captureKind;
    let patternInput_1;
    const patternInput = reactApi.useState(() => {
        const existingValue = window.localStorage.getItem("camera.captureViaInput");
        if (isNullOrWhiteSpace(existingValue)) {
            return false;
        }
        else {
            const result = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(bool_type, undefined, undefined)), existingValue);
            if (result.tag === 1) {
                console.error(some(`Unable to get ${"camera.captureViaInput"} from local storage`), result.fields[0]);
                return false;
            }
            else {
                return result.fields[0];
            }
        }
    });
    patternInput_1 = [patternInput[0], (value_1) => {
        const json = toString_2(4, Auto_generateBoxedEncoder_437914C6(bool_type, undefined, undefined, undefined)(value_1));
        window.localStorage.setItem("camera.captureViaInput", json);
        patternInput[1](value_1);
    }];
    let patternInput_3;
    const patternInput_2 = reactApi.useState(() => {
        const existingValue_1 = window.localStorage.getItem("camera.preferedDevice");
        if (isNullOrWhiteSpace(existingValue_1)) {
            return "";
        }
        else {
            const result_1 = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(string_type, undefined, undefined)), existingValue_1);
            if (result_1.tag === 1) {
                console.error(some(`Unable to get ${"camera.preferedDevice"} from local storage`), result_1.fields[0]);
                return "";
            }
            else {
                return result_1.fields[0];
            }
        }
    });
    patternInput_3 = [patternInput_2[0], (value_1_1) => {
        const json_1 = toString_2(4, Auto_generateBoxedEncoder_437914C6(string_type, undefined, undefined, undefined)(value_1_1));
        window.localStorage.setItem("camera.preferedDevice", json_1);
        patternInput_2[1](value_1_1);
    }];
    const videoRef = reactApi.useRef(undefined);
    let patternInput_4;
    const init = Components_init(patternInput_1[0], patternInput_3[0], videoRef, captureKind);
    patternInput_4 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, (msg, state) => Components_update(onAttachmentsChange, msg, state), (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput_4[0];
    const dispatch = patternInput_4[1];
    const dependencies_2 = [state_1.PreferedCaptureMethod];
    reactApi.useEffect(() => {
        patternInput_1[1](state_1.PreferedCaptureMethod === "fileUpload");
    }, dependencies_2);
    const dependencies_4 = [state_1.PreferedDevice];
    reactApi.useEffect(() => {
        patternInput_3[1](state_1.PreferedDevice);
    }, dependencies_4);
    const patternInput_5 = reactApi.useState(false);
    const showMenu = patternInput_5[0];
    const setShowMenu = patternInput_5[1];
    const ref = reactApi.useRef(undefined);
    const elemRef = ref;
    const callback = reactApi.useCallback((_arg_2) => {
        setShowMenu(false);
    }, []);
    const options_1 = defaultArg(undefined, Impl_defaultPassive);
    const action_1 = (ev) => {
        let copyOfStruct;
        const matchValue = elemRef.current;
        let matchResult, elem_1;
        if (matchValue != null) {
            if (!((copyOfStruct = matchValue, copyOfStruct.contains(ev.target)))) {
                matchResult = 0;
                elem_1 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                callback(ev);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_3 = options_1;
    let addOptions;
    const dependencies_1_2 = [options_3];
    addOptions = reactApi.useMemo(() => Impl_adjustPassive(options_3), dependencies_1_2);
    let removeOptions;
    const dependencies_1_3 = [options_3];
    removeOptions = reactApi.useMemo(() => Impl_createRemoveOptions(options_3), dependencies_1_3);
    let fn;
    const dependencies_1_4 = [action_1];
    fn = reactApi.useMemo(() => ((arg_1) => {
        action_1(arg_1);
    }), dependencies_1_4);
    useEffect(useCallbackRef(() => {
        if (addOptions == null) {
            document.addEventListener("mousedown", fn);
        }
        else {
            const options_1_1 = addOptions;
            document.addEventListener("mousedown", fn, options_1_1);
        }
        return createDisposable(() => {
            if (removeOptions == null) {
                document.removeEventListener("mousedown", fn);
            }
            else {
                const options_2_1 = removeOptions;
                document.removeEventListener("mousedown", fn, options_2_1);
            }
        });
    }));
    const action_3 = (ev_1) => {
        let copyOfStruct_1;
        const matchValue_1 = elemRef.current;
        let matchResult_1, elem_3;
        if (matchValue_1 != null) {
            if (!((copyOfStruct_1 = matchValue_1, copyOfStruct_1.contains(ev_1.target)))) {
                matchResult_1 = 0;
                elem_3 = matchValue_1;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                callback(ev_1);
                break;
            }
            case 1: {
                break;
            }
        }
    };
    const options_5 = options_1;
    let addOptions_1;
    const dependencies_1_5 = [options_5];
    addOptions_1 = reactApi.useMemo(() => Impl_adjustPassive(options_5), dependencies_1_5);
    let removeOptions_1;
    const dependencies_1_6 = [options_5];
    removeOptions_1 = reactApi.useMemo(() => Impl_createRemoveOptions(options_5), dependencies_1_6);
    let fn_1;
    const dependencies_1_7 = [action_3];
    fn_1 = reactApi.useMemo(() => ((arg_2) => {
        action_3(arg_2);
    }), dependencies_1_7);
    useEffect(useCallbackRef(() => {
        if (addOptions_1 == null) {
            document.addEventListener("touchstart", fn_1);
        }
        else {
            const options_1_2 = addOptions_1;
            document.addEventListener("touchstart", fn_1, options_1_2);
        }
        return createDisposable(() => {
            if (removeOptions_1 == null) {
                document.removeEventListener("touchstart", fn_1);
            }
            else {
                const options_2_2 = removeOptions_1;
                document.removeEventListener("touchstart", fn_1, options_2_2);
            }
        });
    }));
    const videoCapture = (Components_State__get_CaptureMethod(state_1) === "fileUpload") && (Components_SupportedVideoFormat != null);
    let switchButton;
    const matchValue_2 = state_1.Devices;
    switchButton = (!isEmpty(matchValue_2) ? (!isEmpty(tail(matchValue_2)) ? (isEmpty(tail(tail(matchValue_2))) ? createElement("button", createObj(Helpers_combineClasses("button", toList(delay(() => append(singleton(["className", "is-info"]), delay(() => append(singleton(["className", "is-small"]), delay(() => append(singleton(["children", createElement("span", createObj(Helpers_combineClasses("icon", ofArray([["className", "is-small"], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-retweet"])), [])]]))))]), delay(() => append(equals(state_1.CurrentDevice, head(matchValue_2)) ? singleton(["title", `Swap camera to ${head(tail(matchValue_2)).label}`]) : singleton(["title", `Swap camera to ${head(matchValue_2).label}`]), delay(() => singleton(["onClick", (_arg_3) => {
        dispatch(new Components_VideoMsg(2, [equals(state_1.CurrentDevice, head(matchValue_2)) ? head(tail(matchValue_2)) : head(matchValue_2)]));
    }])))))))))))))) : createElement("div", createObj(Helpers_combineClasses("dropdown", toList(delay(() => append(singleton(["ref", ref]), delay(() => append(showMenu ? singleton(["className", "is-active"]) : empty_1(), delay(() => {
        let elems_5, elms_2, elems_2, elms, elms_1, elms_3;
        return singleton((elems_5 = [(elms_2 = singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["className", "is-small"], (elems_2 = [(elms = singleton_1(Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-retweet"])), [])), createElement("span", {
            className: "icon",
            children: reactApi.Children.toArray(Array.from(elms)),
        })), (elms_1 = singleton_1(Fa_i(toList(delay(() => (showMenu ? singleton(new Fa_IconOption(11, ["fas fa-chevron-up"])) : singleton(new Fa_IconOption(11, ["fas fa-chevron-down"]))))), [])), createElement("span", {
            className: "icon",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_2))]), ["title", "Swap camera"], ["onClick", (_arg_4) => {
            setShowMenu(!showMenu);
        }]]))))), createElement("div", {
            className: "dropdown-trigger",
            children: reactApi.Children.toArray(Array.from(elms_2)),
        })), createElement("div", createObj(Helpers_combineClasses("dropdown-menu", singleton_1(["children", (elms_3 = map_1((device) => createElement("a", createObj(Helpers_combineClasses("dropdown-item", toList(delay(() => append(singleton(["children", device.label]), delay(() => (equals(state_1.CurrentDevice, device) ? singleton(["className", "is-active"]) : singleton(["onClick", (e) => {
            e.preventDefault();
            dispatch(new Components_VideoMsg(2, [device]));
        }]))))))))), state_1.Devices), createElement("div", {
            className: "dropdown-content",
            children: reactApi.Children.toArray(Array.from(elms_3)),
        }))]))))], ["children", reactApi.Children.toArray(Array.from(elems_5))]));
    })))))))))) : defaultOf()) : defaultOf());
    const fileCapture = toList(delay(() => (((Components_State__get_CaptureMethod(state_1) === "fileUpload") && (captureKind === "image")) ? append(singleton(createElement("label", createObj(ofArray([["for", "image-capture"], op_PlusPlus(["className", "button"], ["className", "is-light"]), ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-camera"])), [])]])))), delay(() => singleton(createElement("input", {
        id: "image-capture",
        className: "is-hidden",
        disabled: true,
        accept: "image/*",
        multiple: true,
        capture: "environment",
        onChange: (ev_2) => {
            const fileList = ev_2.target.files;
            if (!(fileList == null)) {
                dispatch(new Components_VideoMsg(11, [map_1((f) => [newGuid(), f], toList(delay(() => map_2((i) => fileList.item(i), rangeDouble(0, 1, fileList.length - 1)))))]));
            }
        },
    })))) : ((videoCapture && (captureKind === "video")) ? append(singleton(createElement("label", createObj(ofArray([["for", "video-capture"], op_PlusPlus(["className", "button"], ["className", "is-light"]), ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-video"])), [])]])))), delay(() => singleton(createElement("input", {
        id: "video-capture",
        className: "is-hidden",
        disabled: true,
        accept: "video/*",
        multiple: true,
        onChange: (ev_3) => {
            const fileList_1 = ev_3.target.files;
            if (!(fileList_1 == null)) {
                dispatch(new Components_VideoMsg(11, [map_1((f_1) => [newGuid(), f_1], toList(delay(() => map_2((i_1) => fileList_1.item(i_1), rangeDouble(0, 1, fileList_1.length - 1)))))]));
            }
        },
        capture: "environment",
    })))) : empty_1()))));
    const takePicture = ((captureKind === "image") && (Components_State__get_CaptureMethod(state_1) === "device")) ? createElement("button", createObj(Helpers_combineClasses("button", ofArray([["disabled", disabled], ["className", "is-success"], ["className", "is-small"], ["title", "Take Photo"], ["onClick", (_arg_5) => {
        dispatch(new Components_VideoMsg(7, []));
    }], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-camera"])), [])]])))) : defaultOf();
    let startRecording;
    if ((captureKind === "video") && !videoCapture) {
        if (Components_SupportedVideoFormat != null) {
            const mimeType = Components_SupportedVideoFormat;
            startRecording = createElement("button", createObj(Helpers_combineClasses("button", ofArray([["disabled", disabled ? true : state_1.IsRecording], ["className", "is-success"], ["className", "is-small"], ["title", "Start Recording"], ["onClick", (_arg_6) => {
                dispatch(new Components_VideoMsg(8, [mimeType]));
            }], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-camera"])), [])]]))));
        }
        else {
            startRecording = defaultOf();
        }
    }
    else {
        startRecording = defaultOf();
    }
    const stopRecording = ((captureKind === "video") && !videoCapture) ? ((Components_SupportedVideoFormat != null) ? createElement("button", createObj(Helpers_combineClasses("button", ofArray([["disabled", disabled ? true : !state_1.IsRecording], ["className", "is-danger"], ["className", "is-small"], ["title", "Stop Recording"], ["onClick", (_arg_7) => {
        dispatch(new Components_VideoMsg(9, []));
    }], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-camera"])), [])]])))) : defaultOf()) : defaultOf();
    return createElement("div", createObj(ofArray([["className", "videofeed"], (elems_8 = toList(delay(() => {
        let matchValue_3, elms_4;
        return append((matchValue_3 = Components_State__get_CaptureMethod(state_1), (matchValue_3 === "device") ? singleton((elms_4 = toList(delay(() => append(singleton(switchButton), delay(() => append(singleton(takePicture), delay(() => append(singleton(startRecording), delay(() => append(singleton(stopRecording), delay(() => fileCapture)))))))))), createElement("div", {
            className: "buttons",
            children: reactApi.Children.toArray(Array.from(elms_4)),
        }))) : singleton(defaultOf())), delay(() => append(singleton(defaultArg(map((d_8) => d_8.label, state_1.CurrentDevice), "No Camera")), delay(() => append(singleton(createElement("video", createObj(toList(delay(() => append(singleton(["ref", videoRef]), delay(() => append(singleton(["muted", true]), delay(() => ((Components_State__get_CaptureMethod(state_1) === "fileUpload") ? singleton(["className", "is-hidden"]) : empty_1())))))))))), delay(() => {
            let children_5;
            return isEmpty(state_1.Attachments) ? singleton(defaultOf()) : singleton((children_5 = map_1((tupledArg) => {
                let elems_7;
                const id = tupledArg[0];
                const attachment = tupledArg[1];
                return createElement("li", createObj(ofArray([["key", id], (elems_7 = toList(delay(() => append(singleton(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["disabled", disabled], ["className", "is-danger"], ["className", "is-small"], ["onClick", (_arg_8) => {
                    dispatch(new Components_VideoMsg(12, [id]));
                }], ["children", Fa_i(singleton_1(new Fa_IconOption(11, ["fas fa-times"])), [])]]))))), delay(() => (attachment.type.startsWith("image") ? singleton(createElement("img", {
                    src: URL.createObjectURL(attachment),
                })) : (attachment.type.startsWith("video") ? singleton(createElement("video", {
                    src: URL.createObjectURL(attachment),
                    controls: true,
                })) : empty_1())))))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
            }, state_1.Attachments), createElement("ul", {
                children: reactApi.Children.toArray(Array.from(children_5)),
            })));
        }))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

